import {
  FaInstagram,
  FaWhatsapp,
  FaPhoneAlt,
} from "react-icons/fa";

const FloatingContactButtons = () => {
  const contacts = [
    {
      name: "Call Us",
      href: "tel:+918332029863",
      icon: FaPhoneAlt,
      label: "Call IA4Solutions at 8332029863",
      className:
        "bg-blue-600 hover:bg-blue-700 focus:ring-blue-500",
    },
    {
      name: "WhatsApp",
      href: "https://wa.me/918332029863",
      icon: FaWhatsapp,
      label: "Chat with IA4Solutions on WhatsApp",
      className:
        "bg-[#25D366] hover:bg-[#20bd5a] focus:ring-[#25D366]",
      pulse: true,
    },
    {
      name: "Instagram",
      href: "https://www.instagram.com/innovativeacademyitsolutions/",
      icon: FaInstagram,
      label: "Visit IA4Solutions on Instagram",
      className:
        "bg-gradient-to-tr from-yellow-400 via-pink-500 to-purple-600 hover:brightness-110 focus:ring-pink-500",
    },
  ];

  return (
    <div
      aria-label="IA4Solutions contact and social links"
      className="
        fixed
        bottom-24
        right-4
        z-40
        flex
        flex-col
        items-center
        gap-3
        sm:bottom-24
        sm:right-5
      "
    >
      {contacts.map((contact) => {
        const Icon = contact.icon;

        return (
          <div
            key={contact.name}
            className="relative"
          >
            {/* WhatsApp Pulse */}
            {contact.pulse && (
              <span
                aria-hidden="true"
                className="
                  absolute
                  inset-0
                  rounded-full
                  bg-[#25D366]
                  opacity-30
                  animate-ping
                "
              />
            )}

            <a
              href={contact.href}
              target={contact.href.startsWith("tel:") ? undefined : "_blank"}
              rel={
                contact.href.startsWith("tel:")
                  ? undefined
                  : "noopener noreferrer"
              }
              aria-label={contact.label}
              title={contact.name}
              className={`
                group
                relative
                flex
                h-12
                w-12
                sm:h-14
                sm:w-14
                items-center
                justify-center
                rounded-full
                border-2
                border-white
                text-white
                shadow-[0_8px_24px_rgba(15,23,42,0.20)]
                ring-1
                ring-black/5
                transition-all
                duration-300
                hover:-translate-y-1
                hover:scale-105
                hover:shadow-[0_12px_30px_rgba(15,23,42,0.28)]
                focus:outline-none
                focus:ring-2
                focus:ring-offset-2
                dark:border-gray-900
                dark:ring-white/10
                dark:focus:ring-offset-gray-900
                ${contact.className}
              `}
            >
              <Icon
                aria-hidden="true"
                className="
                  text-[19px]
                  transition-transform
                  duration-300
                  group-hover:scale-110
                  sm:text-[21px]
                "
              />

              {/* Tooltip */}
              <span
                className="
                  pointer-events-none
                  absolute
                  right-full
                  mr-3
                  hidden
                  whitespace-nowrap
                  rounded-lg
                  border
                  border-gray-700
                  bg-gray-900
                  px-3
                  py-2
                  text-xs
                  font-semibold
                  text-white
                  opacity-0
                  translate-x-2
                  shadow-xl
                  transition-all
                  duration-200
                  group-hover:opacity-100
                  group-hover:translate-x-0
                  group-focus-visible:opacity-100
                  group-focus-visible:translate-x-0
                  sm:block
                "
              >
                {contact.name}
              </span>
            </a>
          </div>
        );
      })}
    </div>
  );
};

export default FloatingContactButtons;